var React = require('react');

function Flatten (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"Icon For Flatten"),React.createElement("g",{"stroke":"none","strokeWidth":"1","fill":"none","fillRule":"evenodd","key":1},[React.createElement("rect",{"opacity":"0","x":"0","y":"0","width":"24","height":"24","key":0}),React.createElement("circle",{"fill":"#000000","cx":"9","cy":"15","r":"6","key":1}),React.createElement("path",{"d":"M8.8012943,7.00241953 C9.83837775,5.20768121 11.7781543,4 14,4 C17.3137085,4 20,6.6862915 20,10 C20,12.2218457 18.7923188,14.1616223 16.9975805,15.1987057 C16.9991904,15.1326658 17,15.0664274 17,15 C17,10.581722 13.418278,7 9,7 C8.93357256,7 8.86733422,7.00080962 8.8012943,7.00241953 Z","fill":"#000000","opacity":"0.3","key":2})])]);
}

Flatten.defaultProps = {"width":"24px","height":"24px","viewBox":"0 0 24 24","version":"1.1"};

module.exports = Flatten;

Flatten.default = Flatten;
